import React, { Component } from 'react';
import PropTypes from 'prop-types';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

import styles from './CardPagination.scss';
const rootClassName = styles.rootClassName;

class CardPagination extends Component {
  getBullet(index, isCurrent) {
    const className =
      rootClassName +
      '-bullet ' +
      (isCurrent ? rootClassName + '-bullet-actived' : '');
    return <div className={className} key={index}></div>;
  }

  getBullets(currIndex) {
    return (
      <div className={rootClassName + '-bullets'}>
        {this.props.children.map((child, index) => {
          return this.getBullet(index, currIndex === index);
        })}
      </div>
    );
  }

  getItemElement(child, currIndex) {
    return (
      <div className={rootClassName + '-item'} key={currIndex}>
        {child}
        {/* { this.getBullets(currIndex) } */}
      </div>
    );
  }

  getElementItems() {
    let childrenElements = [];
    if (this.props.children && this.props.children.length) {
      this.props.children.map((child, index) => {
        childrenElements.push(this.getItemElement(child, index));
        return child;
      });
      return childrenElements;
    }
    throw new Error(
      'Você precisa adicionar pelo menos um elemento filho ao componente CardPagination.'
    );
  }

  getClasses() {
    let classes = [rootClassName];
    if (this.props.CarouselProps && this.props.CarouselProps.className) {
      classes.push(this.props.CarouselProps.className);
    }
    if (this.props.className) {
      classes.push(this.props.className);
    }
    if (this.props.centered) {
      classes.push(rootClassName + '-centered');
    }
    return classes.join(' ');
  }

  render() {
    const allProps = {
      showThumbs: false,
      showArrows: false,
      showIndicators: false,
      showStatus: false,
      ...this.CarouselProps,
      swipeable: false,
      selectedItem: this.props.slideIndex,
      className: this.getClasses(),
    };
    return <Carousel {...allProps}>{this.getElementItems()}</Carousel>;
  }
}

CardPagination.propTypes = {
  CarouselProps: PropTypes.object,
  slideIndex: PropTypes.number,
  centered: PropTypes.bool,
};

export default CardPagination;
